export default "__VITE_ASSET__lvxsZFG0__"